"use strict";

const state = {
  contractor: {
    filters: {},
    result: []
  }
};

const mutations = {
  cacheLastSearchContractor(state, data) {
    state.contractor = Object.assign({}, data);
  }
};

export default { state, mutations };
